import { render, staticRenderFns } from "./LabelTextCounter.vue?vue&type=template&id=c86de162&scoped=true"
import script from "./LabelTextCounter.vue?vue&type=script&lang=js"
export * from "./LabelTextCounter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c86de162",
  null
  
)

export default component.exports